<template>
    <v-container fluid>
        <material-card
        color="primary"
        title="Daftar Menu & User Access Matrix Sistem"
        class="card-wrapper"
        >
        <form >
          <div style="height: 80px" class="form-input row">
            <div class="col-4">
              <p class="label font-weight-bold mb-1">Nama Peran</p>
              <v-text-field
                v-model="searchForm.peran"
                placeholder="Cari berdasarkan nama Peran"
                dense
                outlined
                clearable
              />
            </div>
            <div class="col-4">
              <p class="label font-weight-bold mb-1">Nama Menu</p>
              <v-text-field
                v-model="searchForm.menu"
                placeholder="Cari berdasarkan nama Peran"
                dense
                outlined
                clearable
              />
            </div>
            <div class="col-2">
              <p class="label font-weight-bold mb-1"><br></p>
              <v-btn
                  color="primary"
                  class="mr-4"
                  @click="getData()"
              >
                Cari
              </v-btn>
            </div>
          </div>
          <br>
        </form>
        <v-card>
        <v-data-table
            :headers="headers"
            :items="menuperans"
            :search="search"
            :loading="isLoading"
            loading-text="Memuat data..."
            no-data-text="Data Menu tidak ditemukan"
            no-results-text="Data Menu tidak ditemukan"
            hide-default-footer
        >
          <template v-slot:footer="{ props, on }">
            <esign-table-footer
            :pagination="props.pagination"
            :options="props.options"
            @update:options="on['update:options']"
            />
          </template>
          <template v-slot:item.list_menu="{ item }">
            {{ item.list_menu.slice(0, maxLength).join(' | ') }}
          </template>
          <template v-slot:item.aksi="{ item }">
            <v-btn class="mx-1 mt-1 mb-1" x-small color="primary" dark @click="detailItem(item)"><v-icon small class="mr-1"> mdi-eye </v-icon>Detail</v-btn>
          </template>
        </v-data-table>
        </v-card>
        <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="5000" :top="true">
          {{ snackbarText }}
          <v-btn dark text @click="snackbar = false">Tutup</v-btn>
        </v-snackbar>
        </material-card>
    </v-container>
  </template>

<script>
import { apiServer } from "../../setup-axios";

export default {
  data () {
    return {
      menuperans: [],
      search: '',
      snackbar: false,
      snackbarText: "",
      snackbarColor: "",
      isLoading: true,
      dialog: false,
      totalData: 0,
      maxLength: 8,
      headers: [
        {
          text: 'Nama Peran',
          align: 'start',
          sortable: true,
          value: 'nama_peran',
        },
        { text: 'Daftar Menu', 
          sortable: false,
          value: 'list_menu' 
        },
        { text: 'Aksi',
          sortable: false,
          value: 'aksi' },
      ],
      searchForm: {
        peran: "",
        menu: "",
      }
    }
  },
  created() {
    console.log("loading")
    this.getData();
  },
  methods: {
    getData() {
      this.isLoading = true;
      console.log(this.isLoading);
      apiServer
        .get("/menu/allmenuperan", {
          params: {
            peran: this.searchForm.peran,
            menu: this.searchForm.menu,
          }
        })
        .then(response => {
          this.menuperans = response.data.data;
          this.isLoading = false;
          console.log("loaded")
          console.log(this.menuperans)
          this.currentPeran = localStorage.getItem("currentPeran")
          this.totalData = response.data.total
          if(localStorage.getItem("updateSuccess") != null) {
            this.showSnackbar("orange", localStorage.getItem("updateSuccess"));
            this.close()
            localStorage.removeItem("updateSuccess")
          }
        })
        .catch(error => {
          console.log("There was an error:", error.response); // Logs out the error
          this.isLoading = false;
        });
    },
    showSnackbar(color, message) {
      console.log("snack " + color + " - " + message);
      this.snackbar = true;
      this.snackbarText = message;
      this.snackbarColor = color;
    },
    showMessage () {
      this.showSnackbar(
          this.$store.state.snackbar.snackbarColor,
          this.$store.state.snackbar.snackbarText
      )
      this.$store.dispatch('setSnackbar', {
        snackbarColor: null,
        snackbarText: null,
      })
    },
    detailItem(item){
      this.$router.push('/menu/peran/' + item.id_peran);
    },
  }
}
</script>